/**
 * AnnouncementMediaTypeService
 * Service for managing announcement media types
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for announcement media type CRUD operations
 */
export class AnnouncementMediaTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AnnouncementMediaTypeService.DEFAULT_SERVICE_PATH,
            basePath: AnnouncementMediaTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
AnnouncementMediaTypeService.DEFAULT_SERVICE_PATH = 'announcements';
AnnouncementMediaTypeService.BASE_PATH = 'api/announcement-media-types';
//# sourceMappingURL=AnnouncementMediaTypeService.js.map